import { inject, InjectionToken, Provider } from '@angular/core';
import { ORGANIZATION_FACILITIES_SIGNAL_STORE } from '../signal-store/facilities.signal.store';
import { OrganizationFacilitiesSignalState } from '../../types';

export const FACILITIES_TOKEN =
  new InjectionToken<OrganizationFacilitiesSignalState>(
    'Organization Facilities',
  );

export const FACILITIES_PROVIDER: Provider = {
  provide: FACILITIES_TOKEN,
  useClass: ORGANIZATION_FACILITIES_SIGNAL_STORE,
};

export function organizationFacilitiesTokenizer() {
  return inject(FACILITIES_TOKEN);
}
